import React from 'react';
import { createContext, useContext } from 'react';
export const PanoramaContext = /*#__PURE__*/createContext({
  startTransaction: () => {},
  finishTransaction: () => {},
  panoramaLogger: () => {},
  errorMonitor: () => ({
    reportError: () => {},
    addBreadcrumb: () => {}
  })
});
export const PanoramaContextProvider = _ref => {
  let {
    children,
    appId,
    panoramaClient,
    tenantId,
    installationId
  } = _ref;
  const essentialData = {
    appId,
    tenantId,
    installationId
  };
  const startTransaction = (name, additionalContext) => panoramaClient == null ? void 0 : panoramaClient.transaction(name).start({
    ...essentialData,
    ...additionalContext
  });
  const finishTransaction = (name, additionalContext) => panoramaClient == null ? void 0 : panoramaClient.transaction(name).finish({
    ...essentialData,
    ...additionalContext
  });
  const panoramaLogger = (message, additionalContext) => panoramaClient == null ? void 0 : panoramaClient.logger().warn(message, {
    ...essentialData,
    ...additionalContext
  });
  const errorMonitor = additionalContext => panoramaClient == null ? void 0 : panoramaClient.errorMonitor({
    data: {
      context: {
        ...essentialData,
        ...additionalContext
      }
    }
  });
  return /*#__PURE__*/React.createElement(PanoramaContext.Provider, {
    value: {
      startTransaction,
      finishTransaction,
      errorMonitor,
      panoramaLogger
    }
  }, children);
};
export const usePanorama = () => useContext(PanoramaContext);
//# sourceMappingURL=PanoramaContext.js.map